import React from 'react';
import useGdprIsAllowed from './Gdpr/useGdprIsAllowed';
import * as styles from './Video.module.scss';
import classnames from 'classnames';
import GdprAllowButton from './Gdpr/GdprAllowButton';
import GdprDialogButton from './Gdpr/GdprDialogButton';
import { GatsbyImage } from "gatsby-plugin-image";

type Props = {
    src: string;
    image?: {
        alt: string;
        src: any;
    }
}
export default function Video (props: Props) {
    const { src, image } = props;
    const isAllowed = useGdprIsAllowed("Youtube");

    return (
        <div className={styles.videoWrapper}>
            {image && <GatsbyImage
                image={{...image.src.childImageSharp.gatsbyImageData, aspectRatio: 1.6 }}
                alt={image.alt}
                title={image.alt} />}

            {!isAllowed && <div className={classnames([styles.noAccess, styles.iframe])}>
                <div className="content">
                    <p className={styles.title}>Um dieses Video zu schauen benötigen wir Ihre Zustimmung in der Privatsphäre.</p>
                    <GdprAllowButton serviceKey="Youtube"><button className="button is-primary">Erlauben und Video anzeigen</button></GdprAllowButton>
                    <GdprDialogButton />
                </div>
            </div>}

            {isAllowed && <iframe 
            className={styles.iframe}
            width="560" 
            height="315" 
            src={src}
             allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture">
                
             </iframe>}

        </div>
    );

}